import Vue from 'vue';
import VueI18n from 'vue-i18n';
import { mergeAll } from 'ramda';

import { SUPPORTED_LOCALES, DEFAULT_LOCALE } from '@/constants/locale';
import { STORAGE_KEY } from '@/constants/storage';

Vue.use(VueI18n);

const i18n = new VueI18n({
  fallbackLocale: DEFAULT_LOCALE,
  silentTranslationWarn: true
});

const loadedLocales = [];

const setI18nLocale = locale => {
  i18n.locale = locale;
  document.querySelector('html').setAttribute('lang', locale);

  return locale;
};

const loadLocale = async locale => {
  const webshopLocale = SUPPORTED_LOCALES.includes(locale) ? locale : DEFAULT_LOCALE;
  const isLocaleLoaded = loadedLocales.includes(webshopLocale);

  if (i18n.locale !== webshopLocale || !isLocaleLoaded) {
    if (isLocaleLoaded) {
      return Promise.resolve(setI18nLocale(webshopLocale));
    }

    return Promise.all([
      import(`@/locale/webshop/${webshopLocale}.json`),
      import(`universkin-shared/src/commonDomainObjects/translations/${webshopLocale}.json`)
    ]).then(([{ default: webshop }, { default: shared }]) => {
      const messages = mergeAll([webshop, shared]);

      i18n.setLocaleMessage(webshopLocale, messages);
      loadedLocales.push(webshopLocale);

      return setI18nLocale(webshopLocale);
    });
  }

  return Promise.resolve(webshopLocale);
};

const localeStorageStore = JSON.parse(localStorage.getItem(STORAGE_KEY));
loadLocale(localeStorageStore ? localeStorageStore.locale : DEFAULT_LOCALE);

export { i18n, loadLocale };
